import React, { lazy, Suspense } from 'react'

const NewsContainer = lazy(() => import('../News/NewsContainer'))

interface NewsViewProps {
  hideMenu?: boolean
  isRetorikNews?: boolean
  loop?: boolean
  fromVeille?: boolean
  handleEndedWithoutloop?: () => void
}

const NewsView = ({ hideMenu, isRetorikNews, loop, fromVeille, handleEndedWithoutloop }: NewsViewProps): JSX.Element => {
  return (
    <Suspense>
      <NewsContainer hideMenu={hideMenu} isRetorikNews={isRetorikNews} loop={loop} handleEndedWithoutloop={handleEndedWithoutloop} fromVeille={fromVeille} />
    </Suspense>
  )
}

export default NewsView
